import React from 'react';
import { CookieModal } from '@epcbuilder/lib/components';
import { Main } from '@epcbuilder/lib/components/Layout';
import { Children } from '@epcbuilder/lib/utils';
import { Footer, TopBar } from '@/components/navigation';

const Layout = ({
  title,
  children,
  onCookieDecision,
}: {
  title: string;
  children: Children;
  onCookieDecision?: () => void;
}) => {
  return (
    <Main title={title}>
      <CookieModal onDecision={onCookieDecision} />
      <TopBar />
      <div className="relative h-full min-h-screen">{children}</div>
      <Footer />
    </Main>
  );
};

export default Layout;
